import { FC, SVGProps } from 'react';

import SvgAutoOut from './assets/check-in/auto-out';
import SvgDecline from './assets/check-in/decline';
import SvgError from './assets/check-in/error';
import SvgGroupInvitation from './assets/check-in/group-invitation';
import SvgOnsite from './assets/check-in/onsite';
import SvgSelfServiceIn from './assets/check-in/self-service-in';
import SvgWait from './assets/check-in/wait';
import SvgInvitationSent from './assets/check-in/invitation-sent';
import SvgCreatedBy from './assets/check-in/created-by';
import SvgCheckedOut from './assets/check-in/checked-out';
import SvgCheckedOutManual from './assets/check-in/checked-out-manual';
import SvgAlert from './assets/check-in/alert';
import SvgSelfServiceOut from './assets/check-in/self-service-out';
import SvgSelfRegistered from './assets/check-in/self-registered';
import SvgChecked from './assets/check-in/check';
import SvgRegistered from './assets/check-in/registered';
import SvgNotInvitationSent from './assets/check-in/invitation-not-sent';
import SvgAutoIn from './assets/check-in/auto-in';
import SvgBlocked from './assets/check-in/blocked';
import SvgCheckedIn from './assets/check-in/checked-in';
import SvgKioskCreatedBy from './assets/check-in/kiosk-created-by';
import SvgAccessible from './assets/parking/parking-accessible';
import SvgElectro from './assets/parking/parking-electro';
import SvgManagement from './assets/parking/parking-management';
import SvgMoto from './assets/parking/parking-moto';
import SvgPool from './assets/parking/parking-pool';
import SvgStandard from './assets/parking/parking-standard';
import SvgTenant from './assets/parking/parking-tenant';
import SvgVip from './assets/parking/parking-vip';
import SvgTruck from './assets/parking/parking-truck';

// Call Logs
import SvgPlay from './assets/call-logs/play';
import SvgCopyPlay from './assets/call-logs/copy-play';

// COMMON
import SvgNotificationWarning from './assets/common/notification-warning';
import SvgShared from './assets/common/shared';
import SvgLock from './assets/common/lock';

import { IconType } from './types';

export const ICON_BY_TYPE: Record<IconType, FC<SVGProps<SVGSVGElement>>> = {
  // Checking
  'checkin-auto-out': SvgAutoOut,
  'checkin-error': SvgError,
  'checkin-group-invitation': SvgGroupInvitation,
  'checkin-onsite': SvgOnsite,
  'checkin-self-service-in': SvgSelfServiceIn,
  'checkin-wait': SvgWait,
  'checkin-invitation-sent': SvgInvitationSent,
  'checkin-created-by': SvgCreatedBy,
  'checkin-checked-out': SvgCheckedOut,
  'checkin-checked-out-manual': SvgCheckedOutManual,
  'checkin-alert': SvgAlert,
  'checkin-self-service-out': SvgSelfServiceOut,
  'checkin-self-registered': SvgSelfRegistered,
  'checkin-registered': SvgRegistered,
  'checkin-invitation-not-sent': SvgNotInvitationSent,
  'checkin-auto-in': SvgAutoIn,
  'checkin-block': SvgBlocked,
  'checkin-checked-in-manual': SvgCheckedIn,
  'checkin-kiosk-created-by': SvgKioskCreatedBy,
  'checkin-decline': SvgDecline,

  // Parking
  'parking-standard': SvgStandard,
  'parking-electro': SvgElectro,
  'parking-moto': SvgMoto,
  'parking-accessibility': SvgAccessible,
  'parking-pool': SvgPool,
  'parking-vip': SvgVip,
  'parking-management': SvgManagement,
  'parking-tenant': SvgTenant,
  'parking-truck': SvgTruck,

  // Call Logs
  'call-logs-play': SvgPlay,
  'call-logs-play-copy': SvgCopyPlay,

  // Common
  checked: SvgChecked,
  'notification-warning': SvgNotificationWarning,
  shared: SvgShared,
  lock: SvgLock
};
